import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Handler";
import { formatDateTime, textCapitalize } from "../../../Helpers/Utils";
import { DOCUMENT_NAMES } from "./vehicleFleetConstants";

// carDocumentUpload/bikeDocumentUpload key a document by its documentName
// (one of DOCUMENT_NAMES) - uploading the same name again replaces the
// existing entry rather than adding a second one, so the existing list
// below is keyed the same way.
const VehicleDocumentsPanel = ({ vehicleType, vehicleId, documents, onSaved }) => {
    const fileRef = useRef(null);
    const [documentName, setDocumentName] = useState(DOCUMENT_NAMES[0]);
    const [validity, setValidity] = useState("");
    const [uploading, setUploading] = useState(false);

    const onUpload = async () => {
        const file = fileRef.current?.files?.[0];
        if (!file) {
            toast.error("Choose a file to upload");
            return;
        }
        setUploading(true);
        const fd = new FormData();
        fd.append("documentName", documentName);
        if (validity) fd.append("validity", validity);
        fd.append("document", file);
        const response = await Handler({ method: "patch", url: `/admin/${vehicleType}/${vehicleId}/documents`, data: fd, formdata: true });
        if (response?.success) {
            toast.success(response?.data?.message || "Document uploaded");
            if (fileRef.current) fileRef.current.value = "";
            setValidity("");
            onSaved?.();
        } else {
            toast.error(textCapitalize(response?.data?.message || "Unable to upload document"));
        }
        setUploading(false);
    };

    return (
        <div>
            {documents?.length ? (
                <div className="d-flex flex-column gap-2 mb-3">
                    {documents.map((doc) => (
                        <div key={doc.documentId || doc.documentName} className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-2">
                            <div>
                                <span className="badge rounded-pill text-bg-light border me-2">{doc.documentName}</span>
                                {doc.validity ? <span className="small text-muted">Valid till {formatDateTime(doc.validity)}</span> : null}
                            </div>
                            <a href={doc.documentUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-secondary">View</a>
                        </div>
                    ))}
                </div>
            ) : (
                <p className="text-muted small">No documents uploaded yet.</p>
            )}

            <div className="row g-2 align-items-end">
                <div className="col-12 col-md-4">
                    <label className="form-label">Document type</label>
                    <select className="form-select" value={documentName} onChange={(e) => setDocumentName(e.target.value)}>
                        {DOCUMENT_NAMES.map((name) => (<option key={name} value={name}>{name}</option>))}
                    </select>
                </div>
                <div className="col-12 col-md-3">
                    <label className="form-label">Validity (optional)</label>
                    <input type="date" className="form-control" value={validity} onChange={(e) => setValidity(e.target.value)} />
                </div>
                <div className="col-12 col-md-3">
                    <label className="form-label">File</label>
                    <input ref={fileRef} type="file" accept="image/*,application/pdf" className="form-control" />
                </div>
                <div className="col-12 col-md-2">
                    <button type="button" className="btn btn-primary btn-sm w-100" onClick={onUpload} disabled={uploading}>
                        {uploading ? "Uploading..." : "Upload"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default VehicleDocumentsPanel;
